export const REPORT_ALARM_LIST = 'REPORT_ALARM_LIST';
export const REPORT_ALARM_LIST_SUCCESS = 'REPORT_ALARM_LIST_SUCCESS';
export const REPORT_ALARM_LIST_ERROR = 'REPORT_ALARM_LIST_ERROR';
export const REPORT_ALARM_DETAILS = 'REPORT_ALARM_DETAILS';

export const RELATED_ALARMS_REPORT = 'RELATED_ALARMS_REPORT';
export const RELATED_ALARMS_REPORT_SUCCESS = 'RELATED_ALARMS_REPORT_SUCCESS';
export const RELATED_ALARMS_REPORT_ERROR = 'RELATED_ALARMS_REPORT_ERROR';